<template>
  <div class="history-wrapper">
    <div class="history-content">
      History coming soon
    </div>

    <div class="history-aside">
      <div class="aside-group">
        <div v-if="isSignedIn" class="aside-section">
          <Dial />
        </div>

        <div class="aside-section qr">
          <QRCode />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from '@/components/v5/desktop/elements/QRCode.vue';
  import Dial from '@/components/v5/desktop/elements/Dial.vue';

  export default {
    components: {
      QRCode,
      Dial,
    },

    computed: {
      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },

      getHistory() {
        if (this.slide.history) {
          return this.slide.history;
        }

        const stories = this.stories;

        if (!stories || !Array.isArray(stories)) return [];

        let rtn = [{
          date: null,
          stories: stories,
        }];

        return rtn;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .history-wrapper {
    max-width: $desktop-max-width;
    margin: 0 auto;
    display: grid;
    grid-template-columns: $desktop-grid-main $desktop-grid-aside;
    height: $desktop-grid-height;
    overflow: hidden;

    @media (max-width: 620px) {
      grid-template-columns: 1fr;
      height: auto;
    }

    .history-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 2rem;
      border-left: 1px solid rgba($neutral-400, 0.25);
      border-right: 1px solid rgba($neutral-400, 0.25);
      overflow-y: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .history-aside {
      border-right: 1px solid rgba($neutral-400, 0.25);

      .aside-group {
        position: sticky;
        bottom: 0;
        border-top: 1px solid rgba($neutral-400, 0.25);
      }

      .aside-section {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1rem;
        border-bottom: 1px solid rgba($neutral-400, 0.25);
        background: $neutral-600;

        .darkmode & {
          background: $neutral-100;
        }
      }
    }
  }
</style>